import { useMemo, useState, useRef, useContext } from "react"
import { UserContext } from "../../store/store"

import { limits } from "../../services/statics"
import useFetch from "../../hooks/useFetch"
import { api } from "../../services/api"
import { getCookie } from "../../helpers/cookies"

import { useQuery } from "../../hooks/useQuery"
import { ModalError } from "../../components/ui/modal/ModalError"
import { ModalOk } from "../../components/ui/modal/ModalOk"
import { msg } from "../../components/ui/modal/utils"
import { Paginator } from "../../components/ui/Paginator"

import { ModalEditarTag } from "../../components/admin/ModalEditarTag"
import { ModalEliminarTag } from "../../components/admin/ModalEliminarTag"
import { config } from "../../config"
import { Trans, useTranslation } from "react-i18next"

//
//
//
// nuevo sistema de tags:
//
//
//
//

export const GestionarTags = () => {
  // state
  const [limit, setLimit] = useState(config.default_limit),
    [offest, setOffset] = useState(1)

  // edit/delete word

  const [selected, setSelected] = useState(null),
    modalEliminar = useState(false),
    modalEditar = useState(false)

  const onClickEditar = (entry, e) => {
    e.preventDefault()
    modalEditar[1](true)
    setSelected(entry)
  }

  const onClickEliminar = (entry, e) => {
    e.preventDefault()
    setSelected(entry)
    modalEliminar[1](true)
  }

  const { url, opt } = useMemo(
    () =>
      api.tags.readAll({
        from: offest,
        limit,
      }),
    [limit, offest]
  )
  const [data, isPending, err, setData] = useFetch({ url, opt })

  const { t } = useTranslation()

  const ListTags = (tags) => {
    const [state] = useContext(UserContext)
    const theme = state.theme === "light" ? "table-striped" : "table-dark"

    return (
      <table className={"table table-hover w-100 mx-auto " + theme}>
        <thead>
          <tr>
            <th>ID</th>
            <th>{t(`admin.tags.name`)}</th>
            <th>
              <center>{t(`admin.tags.is_visible`)}</center>
            </th>
            <th>
              <center>{t(`ui.tables.edit`)}</center>
            </th>
            <th>
              <center>{t(`ui.tables.delete`)}</center>
            </th>
          </tr>
        </thead>
        <tbody style={{ borderTop: "2px solid #4e4e4e" }}>
          {tags.map((tag, ix) => (
            <tr key={ix}>
              <td>{tag.id}</td>
              <td>
                <i>{tag.name}</i>
              </td>
              <td>
                <center>{tag.visible ? "Sí" : "No"}</center>
              </td>
              <td>
                <center>
                  <button
                    type="button"
                    onClick={onClickEditar.bind(this, tag)}
                    className="btn btn-sm tooltip edit-tooltip"
                  >
                    ✏️
                  </button>
                </center>
              </td>
              <td>
                <center>
                  <button
                    type="button"
                    onClick={onClickEliminar.bind(this, tag)}
                    className="btn btn-sm tooltip elim-tooltip"
                  >
                    ❌
                  </button>
                </center>
              </td>
            </tr>
          ))}
        </tbody>
      </table>
    )
  }

  return (
    <>
      {modalEditar[0] && (
        <ModalEditarTag
          show={modalEditar}
          entry={selected}
          setEntries={setData}
        />
      )}

      {modalEliminar[0] && (
        <ModalEliminarTag
          show={modalEliminar}
          entry={selected}
          setEntries={setData}
        />
      )}

      <div className="col-lg-8 col-12" style={{ margin: "0 auto" }}>
        <h4>{t(`admin.tags.manage_tags`)}</h4>

        <div className="d-flex justify-content-end align-items-center flex-row pb-3">
          <div className="form-check">
            <label className="form-check-label">
              {t(`ui.tables.limit`)}
              <select
                className="form-select mini-select mx-2"
                value={limit}
                onChange={(e) => setLimit(parseInt(e.target.value))}
                defaultValue={100}
                style={{ fontSize: "14px" }}
              >
                {limits.map((lim, ix) => (
                  <option key={ix} value={lim}>
                    {lim}
                  </option>
                ))}
              </select>
            </label>
          </div>
        </div>

        {isPending && <p className="my-3">{t(`ui.btns.loading`)}...</p>}
        {err && <p className="my-3">{t(`ui.msgs.something_went_wrong`)}</p>}
        {!isPending && data && ListTags(data.entries)}

        {!isPending && !err && (
          <Paginator
            total={data.total}
            offset={offest}
            radius={3}
            skipers={false}
            iterators={false}
            setOffset={setOffset}
            pageSize={limit}
          />
        )}
      </div>
    </>
  )
}

export const AgregarTag = () => {
  // elements
  const form = useRef()

  // estado
  const [name, setName] = useState(""),
    [visible, setVisible] = useState(false)

  // pal msg de ok
  const [cache, setCache] = useState("")

  const createTag = useQuery(),
    showRes = useState(false)

  const cleanForm = () => {
    form.current.reset()
    setCache(name)
    setName("")
    setVisible(false)
  }

  const onSubmitForm = async (e) => {
    e.preventDefault()
    showRes[1](true)

    const { url, opt } = api.tags.create({
      token: getCookie("jwt"),
      tags: [
        {
          name,
          visible,
        },
      ],
    })

    createTag.url.current = url
    createTag.opt.current = opt
    createTag.run({
      onOk: cleanForm,
    })
  }

  const { t } = useTranslation()

  return (
    <>
      {createTag.res && !createTag.err && (
        <ModalOk
          show={showRes}
          body={msg(
            <Trans
              i18nKey="admin.tags.tag_succesfully_added"
              values={{ tag: cache }}
              components={{ i: <i /> }}
            />
            // <>El tag <i>{cache}</i> ha sido agregado con éxito.</>
          )}
        />
      )}

      {createTag.res && createTag.err && (
        <ModalError id="err-res" show={showRes} res={createTag.res} />
      )}

      {/* formulario */}
      <div className="col-4" style={{ margin: "0 auto" }}>
        <form ref={form}>
          <fieldset>
            <legend>{t(`admin.tags.new_tag`)}</legend>

            <div className="form-group">
              <label className="form-label mt-4">{t(`admin.tags.name`)}</label>
              <input
                onChange={(e) => setName(e.target.value)}
                className="form-control"
                placeholder={t(`admin.tags.placeholder_name`)}
              />
            </div>

            <div className="form-group mt-4 d-flex align-items-center">
              <label className="form-label mb-0">
                {t(`admin.tags.is_visible`)}
              </label>
              <input
                type="checkbox"
                className="ms-3"
                checked={visible}
                onChange={(e) => setVisible(e.target.checked)}
              />
            </div>

            <button
              onClick={onSubmitForm.bind(this)}
              disabled={createTag.isPending}
              type="submit"
              className="btn btn-primary mt-4"
            >
              {createTag.isPending
                ? t(`ui.btns.submiting`) + "..."
                : t(`ui.btns.create`)}
            </button>
          </fieldset>
        </form>
      </div>
    </>
  )
}
